import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  const narrowContainer = `@container (max-width: ${theme.breakpoints.values.sm}px)`;
  return {
    root: {
      width: 343,
      height: 32,
      position: 'absolute',
      top: 16,
      left: 16,
      backgroundColor: theme.palette.background.paper,
      borderRadius: Number(theme.shape.borderRadius) * 1.5,
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      [narrowContainer]: {
        width: 'calc(100% - 104px)',
      },
    },
    rootFormField: {
      position: 'relative',
      width: '100%',
      height: 56,
      boxShadow: 'none',
      top: 'unset',
      left: 'unset',
      backgroundColor: 'inherit',
    },
    rootEmbedded: {
      position: 'relative',
      top: 'unset',
      left: 'unset',
      [narrowContainer]: {
        width: 'auto',
        flex: 1,
        minWidth: 0,
      },
    },
    rootOpen: {
      borderTopLeftRadius: Number(theme.shape.borderRadius) * 1.5,
      borderTopRightRadius: Number(theme.shape.borderRadius) * 1.5,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    inputRoot: {
      width: '100%',
      height: 32,
      padding: '0px 10px !important',
    },
    inputRootFormField: {
      height: 56,
    },
    input: {
      width: '100%',
      height: '100%',
      padding: '0px 8px !important',
      fontSize: theme.typography.subtitle1.fontSize,
    },
    inputFormField: {
      padding: '0px 8px !important',
      fontSize: theme.typography.body1.fontSize,
    },
    paper: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: Number(theme.shape.borderRadius) * 1.5,
      borderBottomRightRadius: Number(theme.shape.borderRadius) * 1.5,
      boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      borderTopWidth: 1.5,
      borderTopColor: theme.palette.grey[300],
      borderTopStyle: 'solid',
    },
    paperFormField: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderTopWidth: 0,
    },
    noOptions: {
      fontSize: theme.typography.body1.fontSize,
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
    },
    option: {
      padding: theme.spacing(1),
    },
    hide: {
      display: 'none',
    },
    icon: {
      width: 16,
      height: 16,
      color: theme.palette.grey[600],
    },
    iconFullView: {
      width: 24,
      height: 24,
    },
    itemIcon: {
      width: 24,
      height: 24,
      color: 'rgb(99, 147, 242)',
    },
    geoEventIcon: {
      width: 24,
      height: 24,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    pointer: {
      cursor: 'pointer',
    },
    itemText: {
      marginTop: 0,
      marginBottom: 0,
      lineHeight: 1.18,
      flex: 1,
    },
    itemSecondary: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    itemSecondaryText: {
      flex: 1,
      paddingRight: theme.spacing(1),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  };
});
